(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('project-detail', {
                url: '/:langcode/projects/:name/:id',

                templateUrl: 'app/projeler/projeler-detay.html',
                controller: 'ProjelerDetayController',
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'projects');
                    }],
                    project: ["notifierSvc", "projectsApi", "$translate", "$transition$", "$rootScope", "$timeout", "historyService", function (notifierSvc, projectsApi, $translate, $transition$, $rootScope, $timeout, historyService) {
                        return projectsApi.get({ id: $transition$.params().id }).$promise.then(function (result) {
                            historyService.set('project', $transition$.params().id);
                            return result;
                        }, function () {
                            $translate('c_prj1').then(function (res) {
                                notifierSvc.show({ message: res, type: "info" });
                            });
                            $timeout(function () {
                                $rootScope.MetaTags.prerender.statusCode = 301;
                                window.redirected = "Location: " + $transition$.router.stateService.href("analysis.country.projects", { langcode: $transition$.params().langcode, country: "world" });
                                $rootScope.MetaTags.prerender.header = window.redirected;
                            }, 0);
                            $transition$.abort();
                            $transition$.router.stateService.go("analysis.country.projects", { langcode: $transition$.params().langcode, country: "world" });
                        });
                    }],

                    geo: ['geoApi', 'project', function (geoApi, project) {
                        if (project && project.Latitude) {
                            var geoAp = geoApi.get({ lat: +project.Latitude, long: +project.Longitude, level: 3 });
                            return geoAp.$promise.then(function (resb) {
                                return resb;
                            });
                        }
                    }],

                    HasRealEstate: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "real-estate-package",
                            "location-package"
                        ]);
                    }],

                    name: ['project', function (project) {
                        return project ? project.Name : "";
                    }],

                    description: ['project', function (project) {
                        return project ? project.Description : "";
                    }],


                    location: ['project', function (project) {
                        return project ? project.Location : "";
                    }],


                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('analysis_projects');
                        $translatePartialLoader.addPart('analysis_election');
                        $translatePartialLoader.addPart('analysis_value');
                        return $translate.refresh();
                    }]
                },
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    name: { type: 'any', raw: true },
                    id: { type: 'any', raw: true }
                },
                metaTags: {
                    title: '{{name}}',
                    description: '{{description}}',
                    properties: {
                        'og:image': ['project', function (project) {
                            return project ? project.Image.replace('https://', 'http://') : "";
                        }],
                        'og:image:secure_url': ['project', function (project) {
                            return project ? project.Image.replace('http://', 'https://') : "";
                        }],
                        'og:type': 'website'
                    }
                }
            });
    }]);

})();
